import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AddressSummaryService } from "@onsip/common/services/api/resources/addressSummary/address-summary.service";
import { RecManagement } from "@onsip/common/services/api/resources/recordingManager/recording-manager";
import { UserAliasService } from "@onsip/common/services/api/resources/userAlias/user-alias.service";
import { filter, map, shareReplay } from "rxjs";

@Component({
  selector: "onsip-recording-manager-view",
  templateUrl: "./recording-manager-view.component.html",
  styleUrls: ["./recording-manager-view.component.scss"],
  standalone: false
})
export class RecordingManagerViewComponent {
  @Input() recManager!: RecManagement;
  @Output() editPanel = new EventEmitter<void>();

  domain$ = this.addressSummaryService.orgState.pipe(
    filter(orgState => !!orgState.length),
    map(orgState => orgState[0].domain)
  );

  extensions$ = this.userAlias.orgState.pipe(
    map(userAlias => {
      return Object.values(userAlias)
        .filter(extension => extension.addressId === this.recManager.addressId)
        .map(filteredExtension => filteredExtension.aliasUsername);
    }),
    shareReplay({ bufferSize: 1, refCount: false })
  );

  constructor(
    private userAlias: UserAliasService,
    private addressSummaryService: AddressSummaryService
  ) {}

  togglePanel() {
    this.editPanel.emit();
  }
}
